import { Link } from "react-router";


export function NotFound () {
    return <>
        <p>Nous n'avons pas trouvé ce que vous cherchez</p>
        <Link to="/">Revenir à l'accueil</Link>
    </>
}